// REDUX
import { IActionResponseData } from '@GFTypes/Responses/ActionResponse';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { store } from '@Managers/Redux/Store';
import { setMaintananceMode } from '@Managers/Redux/AppState/AppState';

class SocketServiceMessageActions {
    storeMessage(message: { event: string; balance?: any; account?: IActionResponseData }) {
        switch (message.event) {
            case 'Logout':
                EventsCenter.emit(EGameEvents.GAME_LOGOUT);
                break;
            case 'BalanceChange':
                EventsCenter.emit(EGameEvents.REFRESH_BALANCE_RECEIVED, { account: message.account });
                break;
            case 'Maintenance':
                store.dispatch(setMaintananceMode(message));
                break;
            default:
                break;
        }
    }
}

export default new SocketServiceMessageActions();
